import { FIELD_TYPES } from "./emailTemplateFieldsConfig";
import { replacePreviewVariables } from "./emailTemplateUtils";

const SECTION_TITLE_SUFFIXES = [
  "_received_title",
  "_working_title",
  "_way_title",
  "_success_title",
  "_heading",
  "_delivery_title",
];

export function isMainTitleField(field) {
  return (
    field.type === FIELD_TYPES.TEXT &&
    field.name.endsWith("_title") &&
    !SECTION_TITLE_SUFFIXES.some((suffix) => field.name.endsWith(suffix))
  );
}

export function isSectionTitleField(field) {
  return (
    field.type === FIELD_TYPES.TEXT &&
    SECTION_TITLE_SUFFIXES.some((suffix) => field.name.endsWith(suffix))
  );
}

export function isGreetingField(field) {
  return field.type === FIELD_TYPES.TEXT && field.name.endsWith("_greeting");
}

export function isLabelField(field) {
  return field.type === FIELD_TYPES.TEXT && field.name.endsWith("_expected_date");
}

export function getPreviewContentFields(fields) {
  return fields.filter((field) => field.type !== FIELD_TYPES.MEDIA);
}

export function buildPreviewBlocks(fields) {
  const contentFields = getPreviewContentFields(fields);
  const blocks = [];

  for (let index = 0; index < contentFields.length; index += 1) {
    const field = contentFields[index];
    const nextField = contentFields[index + 1];

    if (isSectionTitleField(field) && nextField && nextField.name.endsWith("_message")) {
      blocks.push({ type: "highlight", titleField: field, bodyField: nextField });
      index += 1;
      continue;
    }

    if (field.type === FIELD_TYPES.EMAIL) {
      continue;
    }

    blocks.push({ type: "single", field });
  }

  return blocks;
}

export function getFieldPreviewHtml(field, watch) {
  const raw = watch(field.name);
  if (raw === undefined || raw === null || raw === "") return "";
  return replacePreviewVariables(String(raw));
}
